var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1802 9.64623C38.8319 9.46829 39.3936 15.4515 35.3862 14.9272C32.0622 14.8335 31.6409 9.73988 35.1802 9.64623Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2999 0.900656C38.8598 -0.288469 47.4272 2.48306 47.1463 23.897C47.9984 45.4418 36.4815 47.2958 18.1295 47.6329C3.41035 48.8876 -0.222558 33.9438 0.507755 22.1366C0.53588 10.0673 5.8261 -0.138656 19.2999 0.900656ZM43.0265 24.5711C43.0265 11.3127 41.3973 4.29019 26.3411 4.96434C21.8654 5.40441 16.6313 4.73963 12.137 6.26588C3.11072 10.676 4.3561 22.8014 5.18944 31.2097C6.00404 44.7958 17.2681 44.3932 27.8111 42.8764C40.7605 42.1928 43.1483 36.6029 43.0265 24.5711Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4239 15.8727C15.892 15.3859 12.952 31.0881 23.4108 31.5095C33.2422 31.2754 34.7497 18.6724 25.4239 15.8727ZM23.4295 12.2679C39.8902 11.1536 38.879 35.4795 23.3546 35.311C8.64487 34.8615 10.0213 13.5788 23.4295 12.2679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.972d16937626b9aa5c58786a33cdde2d.svg";
export { ForwardRef as ReactComponent };